module.exports = __webpack_public_path__ + "static/img/qr-code-ma.f1dc20e3.png";